import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    IBuildingsPayload,
    IInitialStateBuildings
} from "../types";
import {GetBuildings, GetDeleteBuildings} from "../store/thunk";


const initialState: IInitialStateBuildings = {
    buildings: [],
    buildingsRestore: [],
    isViewBuildingsRestore: false,
    isLoadingBuildings: true,
    selectedBuildingsIDs: [],
    filteredBuildings: []
}
const buildingsSlice = createSlice({
    initialState,
    name: "buildings",
    reducers: {
        setBuildings: (state, action: PayloadAction<{ data: IBuildingsPayload[], defaultLanguage: string }>) => {

            const {data, defaultLanguage} = action.payload;
            state.buildings = data
            state.filteredBuildings = data.flatMap((data) =>
                data.translations
                    .filter((elem) => elem.slug === defaultLanguage && elem.name)
                    .map((elem) => ({
                        id: data.id,
                        abbreviation: elem.abbreviation ?? '',
                        address: elem.address ?? '',
                        name: elem.name ?? '',
                    }))
            );


        },
        deletedRestoreBuildings: (state, action) => {
            state.buildingsRestore = state.buildingsRestore.filter(
                (item) => item.id !== action.payload
            );
        },
        deleteBuildings: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            state.buildings = state.buildings.filter(item => item.id !== id);
        },
        setSelectedBuildingsIDs: (state, action) => {
            state.selectedBuildingsIDs = action.payload
        },

        setBuildingsRestore: (state, action) => {
            state.buildingsRestore = action.payload;
        },


        setIsViewBuildingsRestore: (state) => {

            state.isViewBuildingsRestore = !state.isViewBuildingsRestore;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(GetBuildings.pending, (state) => {
                state.isLoadingBuildings = true;
            })
            .addCase(GetBuildings.fulfilled, (state) => {
                state.isLoadingBuildings = false;

            })
            .addCase(GetBuildings.rejected, (state) => {
                state.isLoadingBuildings = false;
            })
            .addCase(GetDeleteBuildings.pending, (state) => {
                state.isLoadingBuildings = true;
            })
            .addCase(GetDeleteBuildings.fulfilled, (state) => {
                state.isLoadingBuildings = false;

            })
            .addCase(GetDeleteBuildings.rejected, (state) => {
                state.isLoadingBuildings = false;
            });
    },
})
export const {
    setBuildings,
    deletedRestoreBuildings,
    deleteBuildings,
    setSelectedBuildingsIDs,
    setBuildingsRestore,
    setIsViewBuildingsRestore,

} = buildingsSlice.actions;

export default buildingsSlice